const NOOP = () => {};

/**
 * A `matchMedia` that answers width queries as if the viewport were `width` px wide, so
 * `useMediaQuery` inside a scaled preview picks the phone/tablet/desktop layout for that device.
 * Non-width queries (e.g. prefers-color-scheme) fall through to the real window.
 */
export function virtualMatchMedia(width) {
  return (query) => {
    const q = String(query || '');
    const min = /min-width:\s*([\d.]+)px/.exec(q);
    const max = /max-width:\s*([\d.]+)px/.exec(q);
    let matches;
    if (min || max) {
      matches = (!min || width >= parseFloat(min[1])) && (!max || width <= parseFloat(max[1]));
      if (/^\s*not\s/.test(q)) matches = !matches;
    } else {
      matches = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false;
    }
    return {
      matches,
      media: q,
      onchange: null,
      addListener: NOOP,
      removeListener: NOOP,
      addEventListener: NOOP,
      removeEventListener: NOOP,
      dispatchEvent: () => false,
    };
  };
}
